import styled from "styled-components";

export const SchoolsRatingContainer = styled.div`
   width: 100%;
   height: 480px;
   background: #fafafa;
   border: 1px solid #f1f1f1;
   border-radius: 8px;
   margin-top: 24px;
   padding: 24px;

   h4 {
      font-weight: 600;
      font-size: 20px;
      line-height: 32px;
      color: #151f34;
      span {
         font-weight: 400;
      }
   }

   .school--rating {
      display: inline-block;
      flex-direction: column;
      margin-top: 24px;

      .subject {
         margin: 0 0 5px;
         font-size: 14px;
         line-height: 16px;
         letter-spacing: 0.01em;
         color: #3d414b;
         text-transform: capitalize;
      }

      .rating {
         display: inline-block;
         margin-bottom: 8px;
      }
   }
`;
